import './cases-slider.scss'

import Swiper, { Pagination, Navigation } from 'swiper'

function init() {
  const swiper = new Swiper('.cases-slider__slider', {
    modules: [Pagination, Navigation],
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    navigation: {
      nextEl: '.cases-slider__button_next',
      prevEl: '.cases-slider__button_prev',
    },
    pagination: {
      el: '.cases-slider__pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: '.cases-slider__navigation',
          clickable: true,
          renderBullet: function (index, className) {
            const slides = window.CASES_SLIDER || []
            return `<div class="slider-tab ${className}">
              <svg width="21" height="48" viewBox="0 0 21 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.802 36.8144L9.54989 46.438C4.53286 40.4791 1.43577 32.8285 1.29586 24.4121C1.15573 15.9825 4.1565 7.85466 9.20901 1.64587L18.7376 10.9193C16.0104 14.6238 14.4231 19.2281 14.5056 24.1925C14.588 29.1474 16.1833 33.3155 18.802 36.8144Z" stroke="currentColor" stroke-width="2"/>
              </svg>
              <span class="text text_default-400-bold">
                ${slides[index]?.slide_name}
              </span>
            </div>`
          },
        },
      },
    },
  })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init()
  },
  { once: true }
)
